import axios from 'axios';
import authHeader from './auth-header';

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/Feature/analytics`;

class AnalyticsService {

    getOrganizations() {
        return axios.get(`${API_URL}/Organizations`,
            {
            headers: authHeader() 
            })
            .then(response => {
            return response.data;
            });
        }

  getRegisteredLoan(organizationId) {
    return axios.get(`${API_URL}/RegisteredLoan?organizationId=${organizationId}`,
      {
        headers: authHeader() 
      })
      .then(response => {
        return response.data;
      });
  }

}

export default new AnalyticsService();